import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectors } from "@Src/redux/reducers";
import { i18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";
import {
  locales,
  defaultLocale,
  dynamicActivate,
  CHINESE_CODE,
  CHINESE_CODE_FULL,
} from "./i18nUtil";
import { getURIQueryParams } from "@accessdev/arc-ui-react/utils/js";
import { actions } from "@Src/redux/reducers/language/languageSlice";

const { updateLanguage } = actions;

const I18nLoader = ({ children }) => {
  const [isActivated, setIsActivated] = React.useState(false);
  const language = useSelector(selectors.getLanguageSelector);
  const dispatch = useDispatch();

  // check for a language param in the URL, otherwise, use the default.
  let params = getURIQueryParams();
  let languageCode = language === "" ? defaultLocale : language;
  if (params.language && locales[params.language]) {
    // set the passed in language, but replace zh-TW with zh.
    languageCode = params.language.replace(CHINESE_CODE_FULL, CHINESE_CODE);
  }

  useEffect(() => {
    // set language selection in redux for all to use
    dispatch(updateLanguage({ language: languageCode }));
    // set lang attr on html tag for ADA compliance.
    document.querySelector("html").setAttribute("lang", languageCode);
  }, [languageCode, dispatch]);

  useEffect(() => {
    // With this method we dynamically load the catalogs
    dynamicActivate(language, setIsActivated);
  }, [language]);

  if (!isActivated || language === "") return null;
  return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
};

export default I18nLoader;
